import React, { useState } from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import { useAuth } from '@templatean/shared/hooks'
import { storageService } from '@templatean/shared/services'

const SettingsPage: React.FC = () => {
  const { user, logout } = useAuth()
  const [preferences, setPreferences] = useState({
    defaultSignature: true,
    trackByDefault: false,
    autoSuggestResponses: true,
    emailTone: 'professional',
    responseLength: 'medium',
    notifyOnOpen: true,
    notifyOnClick: true
  })

  const handleSavePreferences = async () => {
    await storageService.saveUserPreferences(preferences)
    alert('Preferences saved!')
  }

  const handleLogout = async () => {
    if (confirm('Are you sure you want to sign out?')) {
      await logout()
    }
  }

  return (
    <AppContainer>
      <Header 
        title="Settings"
        subtitle="Configure your Outlook add-in preferences"
      />
      
      <div className="page-content settings-page">
        <section className="settings-section">
          <h2>Account</h2>
          <div className="settings-info">
            <p><strong>Name:</strong> {user?.fullName}</p>
            <p><strong>Email:</strong> {user?.email}</p>
            <p><strong>Tenant:</strong> {user?.tenantId}</p>
          </div>
          <button onClick={handleLogout} className="btn btn-secondary">
            Sign Out
          </button>
        </section>

        <section className="settings-section">
          <h2>Email Preferences</h2>
          
          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.defaultSignature}
                onChange={(e) => setPreferences({
                  ...preferences,
                  defaultSignature: e.target.checked
                })}
              />
              <span>Include signature in generated emails</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.trackByDefault}
                onChange={(e) => setPreferences({
                  ...preferences,
                  trackByDefault: e.target.checked
                })}
              />
              <span>Enable tracking by default for new emails</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.autoSuggestResponses}
                onChange={(e) => setPreferences({
                  ...preferences,
                  autoSuggestResponses: e.target.checked
                })}
              />
              <span>Auto-suggest quick responses</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              Default Email Tone:
              <select
                value={preferences.emailTone}
                onChange={(e) => setPreferences({
                  ...preferences,
                  emailTone: e.target.value
                })}
                className="preference-select"
              >
                <option value="professional">Professional</option>
                <option value="casual">Casual</option>
                <option value="friendly">Friendly</option>
                <option value="formal">Formal</option>
              </select>
            </label>
          </div>

          <div className="preference-item">
            <label>
              Default Response Length:
              <select
                value={preferences.responseLength}
                onChange={(e) => setPreferences({
                  ...preferences,
                  responseLength: e.target.value
                })}
                className="preference-select"
              >
                <option value="short">Short</option>
                <option value="medium">Medium</option>
                <option value="long">Long</option>
              </select>
            </label>
          </div>
        </section>

        <section className="settings-section">
          <h2>Tracking Notifications</h2>
          
          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.notifyOnOpen}
                onChange={(e) => setPreferences({
                  ...preferences,
                  notifyOnOpen: e.target.checked
                })}
              />
              <span>Notify when emails are opened</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.notifyOnClick}
                onChange={(e) => setPreferences({
                  ...preferences,
                  notifyOnClick: e.target.checked
                })}
              />
              <span>Notify when links are clicked</span>
            </label>
          </div>

          <button onClick={handleSavePreferences} className="btn btn-primary">
            Save Preferences
          </button>
        </section>

        <section className="settings-section">
          <h2>About</h2>
          <p>Templatean for Outlook v1.0.0</p>
          <p>© 2024 Templatean Corporation</p>
          <p>
            <a href="https://templatean.com/help/outlook" target="_blank">
              Help & Documentation
            </a>
          </p>
        </section>
      </div>
    </AppContainer>
  )
}

export default SettingsPage